<template>
  <highliter
    v-model="section.name"
    :dublicate="section"
    :dublicate-deep="parentUID"
    class="highlight-element w-auto"
    section-type="element"
    @delete="$emit('delete')"
    @dublicate="$emit('dublicate')"
    @favorite="$emit('favorite', $el)"
    @flow="handleFlow"
    @move-to="to => $emit('move-to', to)"
    @add-subject="$emit('add-subject')"
    @click.stop.native="() => sectionSettings('list')"
  >
    <div
      :data-sid="section.sid"
      :class="[`text-container-${section.sid}`, `--${section.sid}--list --${section.sid}--1`]"
    >
      <ul
        :class="{'element-hidden': !visability('list')}"
        class="list-unstyled list-element list flex flex-column w-auto"
      >
        <li
          v-for="(item, index) in section.options.content.list.items"
          :key="item.label"
          class="flex"
        >
          <div class="d-flex align-items-center">
            <img
              v-if="section.options.content.list.icon === 'custom' && section.options.content.iconUrl"
              :src="section.options.content.iconUrl"
              class="list-icon-img"
            >
            <span
              v-else-if="section.options.content.list.icon === 'custom' && section.options.content.svg"
              class="list-svg"
              v-html="section.options.content.svg"
            />

            <div
              v-else-if="section.options.content.list.customIcon"
              :class="`--lottie-container-${section.sid}`"
            >
              <button-lottie-icon
                :config="section.options.content.list"
              />
            </div>
            <i
              v-else
              :class="section.options.content.list.icon"
              class="list-icon"
            />
          </div>

          <div class="ml-2">
            <content-editable-v2
              ref="content"
              v-model="item.subject.options.content.description.text"
              :customs="item.subject.options.content.description"
              custom-class="text-inherit"
              type="paragraph"
              :section="item.subject"
              :readonly="!canUpdatePages"
              @click.native="() => selectSubjectIndex(index)"
            />
          </div>
        </li>
      </ul>
    </div>
  </highliter>
</template>

<script>
import SectionMixin from '@builder/components/mixins/SectionMixin'
import Highliter from '@builder/components/builder/utils/Highliter'
import PropertiesManager from '../../../mixins/PropertiesManager'
import ResolutionMixin from '../../../mixins/ResolutionMixin'
import ButtonLottieIcon from '@/components/builder/elements/9.icon/ButtonLottieIcon'
import ContentEditableV2 from '@/components/builder/utils/ContentEditableV2'
import {mapGetters} from 'vuex'

export default {
  name: 'FeaturedItems1',
  components: {
    ButtonLottieIcon,
    ContentEditableV2,
    Highliter
  },
  mixins: [
    SectionMixin,
    PropertiesManager,
    ResolutionMixin
  ],
  computed: {
    ...mapGetters('projects', {
      checkPermissions: 'checkPermissions'
    }),
    canUpdatePages () {
      return this.checkPermissions('pages.update')
    }
  },
  methods: {
    selectSubjectIndex (index) {
      this.$set(this.section, 'selectedSubjectIndex', index)
      this.sectionSettings('list')
    }
  }
}
</script>

<style>
.list-element {
  .paragraph {
    text-align: left !important;
    font-size: 1rem;
    color: inherit;
  }

  .list-icon {
    font-size: var(--icon-size);
  }

  svg {
    width: var(--icon-size);
    height: var(--icon-size);
  }

  .list-icon-img {
    width: var(--icon-size);
    height: var(--icon-size);
    object-fit: contain;
  }
}

.list-icon.fa {
  line-height: 1.3;
}
</style>